import { RightOutlined } from '@ant-design/icons';
import './newsCard.less';

export default function NewsCard(props) {
  const { href, title, date, cover, type } = props;

  return (
    <a
      className="common-border-radius transition-hover component-news-list-item"
      target="_blank"
      href={type === 'weChart' ? href : `/news/document-${href}`}
      rel="noreferrer"
    >
      <div className="common-border-radius component-news-img">
        <img
          src={cover}
          alt={title}
        />
      </div>
      <div className="component-news-info">
        <div className="common-font-size-21 component-title">
          {title}
        </div>
        <div className="date-author">
          <div className="common-font-size-12 date-date">{date}</div>
          <div className="author-arrow">
            <div
              className="component-author"
            ></div>
            <RightOutlined style={{ marginTop: 5 }} />
          </div>
        </div>
      </div>
      {/* <div className="mobile-new-item">
        <div className="mobile-new-item-top">
          <img
            src="https://data.alibabagroup.com/ecms-files/1479231421/be7dc33f-e324-4947-a969-6f4b24f25a4f/Alibaba%20Xixi%20Campus_1-1.jpg"
            alt={title}
            className="mobile-new-item-img"
          />
          <div className="common-font-size-21 mobile-new-item-title">
            {title}
          </div>
        </div>
        <div className="mobile-new-item-bottom">
          <div className="common-font-size-12 mobile-new-item-date">
            date
          </div>
          <div className="mobile-new-item-author-arrow">
            <div
              className="mobile-new-item-author"
            ></div>
          </div>
        </div>
      </div> */}
    </a>
  );
}
